// @flow
import firebase from '../firebase';

export const storage = firebase.storage();
if (window.location.hostname === 'localhost') {
	storage?.useEmulator('localhost', 9199);
}

export default storage;
